<template>
    <div>
        <filter-block :is-load-xml="condition.idLoadXml"
                              @download-xls="downloadXls()"
                              :is-load-data="condition.isLoadTable"
                              :is-main-history="listQuery.statusId === statusMain"
                              :items="items"
                              @init-orders-list="applyFilter"
                              ref="filter"></filter-block>
        <div class="list-orders container p-0">
          <div v-if="isMobile" class="row form-group">
            <el-select v-model="listQuery.statusId"
                       class="form-control-el tabs-mobile-select"
                       @change="activateTab($event)"
            >
              <el-option :value="statusMain" label="Основні"></el-option>
              <el-option v-if="! isPartner()" :value="statusPartners" label="Розрахунки з партнерами"></el-option>
              <el-option :value="statusActs" label="Мої акти виплати КВ"></el-option>
            </el-select>
          </div>
          <div v-else class="tabs-block">
              <ul class="status-tabs">
                  <li class="tab">
                      <a @click="activateTab(statusMain)" v-bind:class="{ active: listQuery.statusId === statusMain }" href="javascript:void(0);">Основні</a>
                  </li>
                  <li v-if="! isPartner()" class="tab">
                      <a @click="activateTab(statusPartners)" v-bind:class="{ active: listQuery.statusId === statusPartners }"
                         href="javascript:void(0);">Розрахунки з партнерами</a>
                  </li>
                  <li class="tab">
                      <a @click="activateTab(statusActs)" v-bind:class="{ active: listQuery.statusId === statusActs }"
                         href="javascript:void(0);">Мої акти виплати КВ</a>
                  </li>
              </ul>
          </div>
        </div>
        <div class="score-history">
            <div class="container p-0">
                <div class="header-block">
                    <ul v-if="listQuery.statusId === statusActs" class="columns-block">
                        <li class="column">Назва</li>
                        <li class="column">Торгова точка</li>
                        <li class="column">Дата</li>
                        <li class="column">Сума виплати, грн</li>
                        <li class="column">Акт</li>
                    </ul>
                    <ul v-else class="columns-block">
                        <li class="column">Тип операції</li>
                        <li class="column">Дата</li>
                        <li class="column">Точка продажу</li>
                        <li class="column">Сума, грн</li>
                        <li class="column">Залишок, грн</li>
                    </ul>
                </div>
                <div v-if="condition.isLoadTable" class="score-history__list">
                    <row-block-skeleton v-for="index in 6" :key="index"></row-block-skeleton>
                </div>
                <div v-else-if="listQuery.statusId === statusMain" class="score-history__list">
                    <row-block v-for="item in items" :key="item.id" :item="item"></row-block>
                </div>
                <div v-else-if="listQuery.statusId === statusPartners" class="score-history__list">
                    <row-block-partner v-for="item in items" :key="item.id" :item="item"></row-block-partner>
                </div>
                <div v-else-if="listQuery.statusId === statusActs" class="score-history__list">
                    <row-block-acts v-for="item in items" :key="item.id" :item="item"></row-block-acts>
                </div>
            </div>
        </div>
        <div style="text-align: center">
            <pagination v-show="total > 0" :total="total"
                    :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit"
                    :page-sizes="[10, 15, 20, 30, 50, 100]" @pagination="initList()" />
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { RowBlock, RowBlockSkeleton, RowBlockPartner, RowBlockActs } from './components';
import FilterBlock  from "./components/FilterBlock.vue";
import { list as listTransaction, partnerList as listPartnerTransaction, excel as downloadExcel, partnerExcel as downloadPartnerExcel } from '@/api/transaction';
import { listActs } from "@/api/order";
import { userMixin, partnerMixin } from '@/mixin';
const FileDownload = require('js-file-download');
import Vue from "vue";
import {mapGetters} from "vuex";

export default {
    name: 'list-score',
    components: {RowBlockSkeleton, RowBlock, Pagination, FilterBlock, RowBlockPartner, RowBlockActs },
    mixins: [userMixin, partnerMixin],
    // created: function () {
    //     list().;
    // }
    computed: {
      ...mapGetters('layoutModule', ['isTablet', 'isMobile', 'windowWidth'])
    },
    data: function () {
        return {
            total: 1,
            items: [],
            akts: [],
            requestSeq: 0,
            statusMain: 1,
            statusPartners: 2,
            statusActs: 3,
            condition: {
                isLoadTable: true,
                idLoadXml: false
            },
            listQuery: {
                statusId: 1,
                page: 1,
                limit: 10,
            }
        }
    },
    mounted: function() { // The hook. Here, Vue has already worked its magic.
        this.initList();
    },
    methods: {
        downloadXls: async function () {
            let response;
            Vue.set(this.condition, 'idLoadXml', true);

            if (this.listQuery.statusId === this.statusMain) {
                response = await downloadExcel(this.getQuery());
            } else {
                response = await downloadPartnerExcel(this.getQuery());
            }

            if (response?.data) {
                FileDownload(response.data, 'score.xlsx');
            }

            Vue.set(this.condition, 'idLoadXml', false);
        },
        initList: async function () {
            const seq = ++this.requestSeq;
            let response;
            this.items = [];
            this.condition.isLoadTable = true;

            if (this.listQuery.statusId === this.statusMain) {
                response = await listTransaction(this.getQuery());
            } else if (this.listQuery.statusId === this.statusPartners){
                response = await listPartnerTransaction(this.getQuery());
            } else if (this.listQuery.statusId === this.statusActs){
                response = await listActs(this.getQuery());
            }
            if (seq !== this.requestSeq) return;

            this.items = response.data?.data?.items ?? [];
            this.total = response.data?.data?.total;
            // this.total = data.data?.total;
            this.condition.isLoadTable = false;

            setTimeout(() => {
                let list = document.querySelectorAll('.score-history__item');
                list.forEach((element, index) => {
                    if(index % 2){
                        element.style.background = "#F6F7FB";
                    }
                });
            }, 100);
        },
        clearQuery: function () {
            this.$refs.filter.listQuery = Object.assign({}, this.$refs.filter.listDefaultQuery);
        },
        getQuery: function () {
            return {...this.$refs.filter.listQuery, ...this.listQuery};
        },
        activateTab: function(status) {
            this.$set(this.listQuery, 'statusId', status);
        },
        applyFilter: function () {
            this.listQuery.page = 1;
            return this.initList();
        }
    },
    watch: {
        'listQuery.statusId': function () {
            this.clearQuery();
            this.listQuery.page = 1;
            return this.initList();
        }
    }
}
</script>
